import React from "react";
import utils from "./utils";


class validationHelper {


    validate = async (profile, validationSchema) => {
        let errors = {};

        if (utils.isEmpty(validationSchema))
            return errors;

        await validationSchema.validate(profile, {abortEarly: false}).catch(function (err) {
            // Yup ValidationError carries `.inner` with one entry per failing field.
            // Anything else (TypeError thrown from inside a `.when`, a thrown
            // string, etc.) lacks `.inner` — log it so the bug is visible but
            // don't crash the caller's promise chain.
            if (!err || !Array.isArray(err.inner)) {
                console.error("validationHelper: non-Yup error from schema.validate:", err)
                return
            }
            err.inner.forEach((error) => {
                utils.set(errors, error.path, error.errors)
            });
        });

        return errors;
    };

}

export default new validationHelper();
